import { Color } from '@tmh-website/shared/colors';
import StyledTypo from '@tmh-website/styles/typo';
import ButtonIcon from '@tmh-website/ui/ButtonIcon';
import transparentize from 'polished/lib/color/transparentize';
import styled from 'styled-components';

export const Container = styled.li`
  padding: 24px 0;
  border-bottom: 1px solid ${props => props.theme.color[Color.Neutral_500]};

  &:last-of-type {
    border-bottom: none;
  }
`;

export const MainContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: stretch;
  justify-content: stretch;
`;

export const ImageWrapper = styled.div`
  flex: 0 0 100px;
`;

export const AdjustedImage = styled.img`
  display: block;
  width: 100%;
  object-fit: contain;
  object-position: top center;
  overflow: hidden;
  border-radius: ${props => props.theme.borderRadius.small};
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const DescriptionContainer = styled.div`
  flex-grow: 1;
`;

export const ProductName = styled.p`
  ${StyledTypo.h6Css};
  padding-right: 30px;
  margin: 0 0 4px;
  color: ${props => props.theme.color[Color.Blue_1000_Deep]};
  cursor: pointer;
  transition: opacity ${props => props.theme.transitionTiming};

  &:hover {
    text-decoration: none;
    opacity: 0.6;
  }
`;

export const ActionBarContainer = styled.div`
  position: relative;
  bottom: -8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Price = styled.span`
  ${StyledTypo.h6Css};
  flex-grow: 1;
  margin: 0;
  line-height: ${props => props.theme.lineHeight.small};
`;

export const Quantity = styled(StyledTypo.Typography)`
  opacity: 0.4;
`;

export const ButtonRemove = styled(ButtonIcon)`
  margin-left: ${props => props.theme.gap.small};
  color: ${props => transparentize(0.6, props.theme.color[Color.Blue_1000_Deep])};
`;
